module.exports = __webpack_public_path__ + "static/media/btn_primaryschool_02_Socialmediauserguide.60f1be72.png";